
import '@fortawesome/fontawesome-free/css/all.css'

// Keenicons
import './assets/metronic/vendors/keenicons/duotone/style.css'
import './assets/metronic/vendors/keenicons/filled/style.css'
import './assets/metronic/vendors/keenicons/outline/style.css'
import './assets/metronic/vendors/keenicons/solid/style.css'
import './assets/main.css'
// KTUI JavaScript (includes all component initialization)
import '@keenthemes/ktui/dist/ktui.js'

import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from './App.vue'
import router from './router'
import { useAuthStore } from './stores/authStore'
import { captureAttribution } from './composables/useAttribution'
import { initTracking } from './boot/tracking'
import VCalendar from 'v-calendar';
import 'v-calendar/style.css';

// PrimeVue imports
import PrimeVue from 'primevue/config';
import ManitoPreset from './theme/primevue-preset';
import Toast from 'primevue/toast';
import ToastService from 'primevue/toastservice';

const app = createApp(App)

// Configure PrimeVue with Manito brand colors (teal primary, slate surfaces)
app.use(PrimeVue, {
  theme: {
    preset: ManitoPreset,
    options: {
      prefix: 'p',
      darkModeSelector: '.p-dark',
      cssLayer: {
        name: 'primevue',
        order: 'primevue, tailwind',
      },
    }
  }
});
app.use(ToastService);
app.component('Toast', Toast);

const pinia = createPinia()

app.use(pinia)
app.use(router)

// Capture marketing attribution (UTM / click IDs / referrer) from the
// entry URL before any navigation, then init consent-gated tracking.
captureAttribution()
initTracking()

// Initialize auth store after pinia is set up, but only if not on public booking routes
const currentPath = window.location.pathname
if (!currentPath.startsWith('/book')) {
  const authStore = useAuthStore()
  authStore.initializeAuth()
}
app.use(VCalendar, {})
app.mount('#app')
